export function onScrollAnimation() {
	
	const $window = $(window);
	const $items = $(".has-animation");
	const $body = $("body");
	
	$window.on("scroll load", () => {
		// if ( $body.hasClass("no-touch") ) {
			$items.each((i, it) => {
				if ( $window.scrollTop() > $(it).offset().top - $window.height() * .66 ) {
					$(it).addClass("animate");
				}
			});
		// }
	});
	
	
}


// WEBPACK FOOTER //
// ./assets/js/modules/scroll-animation.js